import { render, staticRenderFns } from "./ScoreTable.vue?vue&type=template&id=c0529bf0&scoped=true"
import script from "./ScoreTable.vue?vue&type=script&lang=js"
export * from "./ScoreTable.vue?vue&type=script&lang=js"
import style0 from "./ScoreTable.vue?vue&type=style&index=0&id=c0529bf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0529bf0",
  null
  
)

export default component.exports